import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';

export const getTagLink = (
	showGlobalNav: boolean,
	type: 'geotag' | 'artist',
	name: string
) => {
	const param = `${type}=${encodeURIComponent(name)}`;

	return `${GlobalRoutes.NewsHome}${
		showGlobalNav ? `?${param}` : `?global_nav=0&${param}`
	}`;
};
